module.exports = __webpack_public_path__ + "static/illustration-sm1-dccd63083843069b00e9e62d62317292.png";